/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Preview_Text_LabelInputs */



/**
* | output |
* | --- |
* | "Preview Text" |
*
* @param {Voice_Manager_Preview_Text_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_preview_text_label = /** @type {((inputs?: Voice_Manager_Preview_Text_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Preview_Text_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Texte d'aperçu")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorschautext")
	if (locale === "it") return /** @type {LocalizedString} */ ("Anteprima testo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительный просмотр текста")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vista previa del texto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("预览文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プレビューテキスト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पूर्वावलोकन पाठ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Texto de pré-visualização")
	return /** @type {LocalizedString} */ ("Preview Text")
});